import { getFormattedNameArgType } from '../types';

export const getFormattedName = ({
  intl,
  menuId,
  isExpanded = true,
  messageConfig,
}: getFormattedNameArgType) => {
  if (!messageConfig?.expandedName || !messageConfig?.collapsedName) {
    return menuId;
  }
  if (isExpanded) {
    return intl.formatMessage(messageConfig.expandedName);
  }
  return intl.formatMessage(messageConfig.collapsedName);
};
